/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：107
 */

"use strict"

function r(e) {
  return (r = "function" === typeof Symbol && "symbol" === typeof Symbol.iterator ? function (e) {
    return typeof e
  } : function (e) {
    return e && "function" === typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e
  })(e)
}
export { r as a }
export default r
